export interface RollsetData {
	// Rollset details for confirmation dialog

	RollsetLetter: string;
	RollsetId: number | null;
	RollsetSectionId: number | null;
	RollsetSectionName: string | null;
	RollsetStandId: number | null;
	RollsetStandName: string | null;
	RollsetTopRollId: number | null;
	RollsetTopRollName: string | null;
	RollsetBottomRollId: number | null;
	RollsetBottomRollName: string | null;
	IsInActiveRollset: boolean;
}

export const ROLLSET_DATA_INITIAL_VALUES: RollsetData = {
	// Rollset details for confirmation dialog
	RollsetLetter: "",
	RollsetId: null,
	RollsetSectionId: null,
	RollsetSectionName: null,
	RollsetStandId: null,
	RollsetStandName: null,
	RollsetTopRollId: null,
	RollsetTopRollName: null,
	RollsetBottomRollId: null,
	RollsetBottomRollName: null,
	IsInActiveRollset: false,
};
